(function () {
  function formatDate(date) {
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    return day + '/' + month + '/' + year;
  }

  function addDays(days) {
    var date = new Date();
    date.setHours(12, 0, 0, 0);
    date.setDate(date.getDate() + days);
    return date;
  }

  function updateShippingDates() {
    document.querySelectorAll('.product-shipping[data-lead-days], .cart-item__shipping[data-lead-days]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-lead-days'), 10);
      if (!days || days < 1) return;

      var weeks = parseInt(el.getAttribute('data-lead-weeks'), 10);
      var weeksMax = parseInt(el.getAttribute('data-lead-weeks-max'), 10);
      var shipDate = formatDate(addDays(days));
      var display = shipDate;

      if (weeksMax && weeks && weeksMax > weeks) {
        display = shipDate + ' – ' + formatDate(addDays(weeksMax * 7));
      }

      el.textContent = 'Est. shipping date: ' + display;
    });
  }

  window.updateProductShippingDates = updateShippingDates;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateShippingDates);
  } else {
    updateShippingDates();
  }
})();
